// styles
import Styled from './SortTags.styled';

// utils
import _map from 'lodash/map';

// hooks
import { useTranslation } from 'react-i18next';
import { FLIGHT_CARD_TAGS } from '@/constants/content.constants';
import { buildTestId } from '@/utils/helpers.utils';
import { TEST_ID_PREFIX } from '@/constants/common.constants';

type SortTagsProps = {
  selectedTags: string[];
  index: number;
};

function SortTags({ selectedTags, index }: SortTagsProps): JSX.Element {
  const { t } = useTranslation();
  const testId = buildTestId(TEST_ID_PREFIX.SEARCH_RESULT_CARD, `Tags-${index}`);
  const currentSelectedTags = selectedTags.map((tag) => FLIGHT_CARD_TAGS[tag]);

  return (
    <Styled.Wrapper data-testid={testId}>
      {_map(currentSelectedTags, (tag, index) => (
        <Styled.SortTag
          testId={buildTestId(testId, `${tag.text}-${index}`)}
          key={index}
          type="tint"
          appearance={tag.appearance}
        >
          {t(tag.text) as string}
        </Styled.SortTag>
      ))}
    </Styled.Wrapper>
  );
}

export default SortTags;
